<template>
  <div class="contract-information-page" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="终端服务计划详情"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">申请信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item">
          <span>申请人：</span>{{ formData.approveVO && formData.approveVO.staffName }}
        </div>
        <!-- <div class="contract-apply-item"><span>提交时间：</span>{{ formData.updateTime | getTime }}</div> -->
        <div class="contract-apply-item"><span>所在部门：</span>{{ formData.organisationName }}</div>
      </div>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>公司名称：</span>{{ formData.tenantName }}</div>
        <div class="contract-apply-item"><span>选择部门：</span>{{ formData.organisationName }}</div>
        <div class="contract-apply-item"><span>计划年份：</span>{{ formData.planYear }}年度</div>
      </div>
      <img
        v-show="formData.approveVO && formData.approveVO.approveState !== 'N'"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
    </div>
    <!-- 合同信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name plan-detail">
        <span>计划详情</span
        ><span
          >
          <!-- <el-button size="mini" type="borderGreen" @click="getExport()">导出</el-button> -->
          <el-button
            size="mini"
            type="info"
            @click="getDownState(2)"
             v-if="formData.downState!='Y'&&formData.approveVO && formData.approveVO.approveState == 'Y'&&formData.approveVO.staffGuid == currentStaffGuid"
            >全量下发</el-button
          ></span
        >
      </p>
      <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" style="padding: 0 16px">
        <div>
          <p class="total-tip">推广总预算合计：<span>{{ getSumAmount(tableData, 1) |
            numDigit }}</span>元&nbsp;&nbsp;&nbsp;所需人数合计：<span>{{ getSumAmount(tableData, 2) }}</span> 人</p>
        </div>
        
        <el-table :data="tableData" tooltip-effect="light" stripe border style="width: 100%" :height="tableHeight">
          <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in fieldData"
            :key="index"
            :prop="item.fieldName"
            :label="item.title"
            show-overflow-tooltip
            header-align="center"
            :align="item.align"
            :width="item.width"
            :fixed="index < 2 ? true : false"
          >
            <template slot-scope="scope">
              <!-- 数组类（区域） -->
              <span v-if="item.type == 'list'"> {{ scope.row[item.fieldName] | listFilter }}</span>
              <!-- 文本类 -->
              <span v-if="item.type == 'text'">{{ scope.row[item.fieldName] || '-' }}</span>
              <!-- 数字类 -->
              <span v-if="item.type == 'num'">{{ scope.row[item.fieldName] | numDigit }}元</span>
              <!-- 下发状态 -->
              <span v-if="item.type == 'downState'">{{ scope.row[item.fieldName] | downState }}</span>
              <!-- 任务 -->
              <span
                v-if="item.type == 'other'"
                class="select-task"
                @click="
                  taskDialogVisible = true;
                  taskData = scope.row[item.fieldName];
                "
                >{{ getTaskName(scope.row[item.fieldName]) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="bank"
            width="100"
            label="操作"
            fixed="right"
            header-align="center"
            align="center"
            v-if="formData.approveVO && formData.approveVO.approveState == 'Y'&&formData.approveVO.staffGuid == currentStaffGuid"
          >
            <template slot-scope="scope">
              <a class="txt-color" v-if="scope.row.downState !== 'Y'" @click="getDownState(1, scope.row.guid)">下发</a>
              <a v-else>下发完毕</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="pageTable.pageIndex"
        :page-size="pageTable.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTable.totalRows"
      >
      </el-pagination> -->
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit-btn-box" v-if="formData">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit"
        >重新提交</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <PersonTaskSum :detail="taskData" v-if="taskDialogVisible" @close="taskDialogVisible = false;"></PersonTaskSum>
    <!-- <el-dialog title="查看市场推广手段" :visible.sync="taskDialogVisible" width="800px" top="15%">
      <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
        <el-table :data="taskData" style="width: 100%">
          <el-table-column prop="projectTaskName" label="平台任务名称" header-align="center" align="left" width="180">
            <template slot-scope="scope">{{ scope.row.projectTaskName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="isContractTask" header-align="center" align="left" label="合同任务" width="90">
            <template slot-scope="scope">{{ scope.row.isContractTask == 'Y' ? '是' : '否' }}</template></el-table-column
          >
          <el-table-column prop="taskContentName" label="项目任务名称" header-align="center" align="left">
          </el-table-column>
          <el-table-column prop="tenantTaskPrice" label="药企报价" header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.tenantTaskPrice | numDigit }}元</template>
          </el-table-column>
          <el-table-column prop="taskPrice" label="业务员报价" header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.taskPrice | numDigit }}元</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import PersonTaskSum from '../serverTaskMangement/components/PersonTaskSum.vue';
export default {
  components: {
    Title,
    PersonTaskSum
  },
  data() {
    return {
      contentMainHeight:window.innerHeight - 300,
      tableHeight:window.innerHeight - 370,
      height: window.innerHeight - 400,
      flowType: '00014',
      fullscreenLoading: false,
      rejectDialogVisible: false,
      passDialogVisible: false,
      taskDialogVisible: false,
      approveSuggest: '',
      formData: {},
      tableData: [],
      contractFileName: '',
      currentOrganisationName: '',
      taskData: [],
      fieldData: [
        { title: '区域', fieldName: 'detailTerritoryList', type: 'list', width: '140', align: 'left' },
        { title: '推广总预算', fieldName: 'generalBudget', type: 'num', width: '140', align: 'right' },
        { title: '1月', fieldName: 'januaryBudget', type: 'num', width: '120', align: 'right' },
        { title: '2月', fieldName: 'februaryBudget', type: 'num', width: '120', align: 'right' },
        { title: '3月', fieldName: 'marchBudget', type: 'num', width: '120', align: 'right' },
        { title: '4月', fieldName: 'aprilBudget', type: 'num', width: '120', align: 'right' },
        { title: '5月', fieldName: 'mayBudget', type: 'num', width: '120', align: 'right' },
        { title: '6月', fieldName: 'juneBudget', type: 'num', width: '120', align: 'right' },
        { title: '7月', fieldName: 'julyBudget', type: 'num', width: '120', align: 'right' },
        { title: '8月', fieldName: 'augustBudget', type: 'num', width: '120', align: 'right' },
        { title: '9月', fieldName: 'septemberBudget', type: 'num', width: '120', align: 'right' },
        { title: '10月', fieldName: 'octoberBudget', type: 'num', width: '120', align: 'right' },
        { title: '11月', fieldName: 'novemberBudget', type: 'num', width: '120', align: 'right' },
        { title: '12月', fieldName: 'decemberBudget', type: 'num', width: '120', align: 'right' },
        { title: '所需人数', fieldName: 'needPersonNum', type: 'text', width: '100', align: 'right' },
        { title: '市场拓展手段', fieldName: 'templateDetailJson', type: 'other', width: '180', align: 'left' },
        { title: '合同名称', fieldName: 'contractName', type: 'text', width: '140', align: 'left' },
        { title: '服务商', fieldName: 'servicerName', type: 'text', width: '180', align: 'left' },
        { title: '下发状态', fieldName: 'downState', type: 'downState', width: '110', align: 'left' },
        { title: '月度合作上限', fieldName: 'monthMaxMoney', type: 'num', width: '120', align: 'right' },
      ],
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: false,
      currentStaffGuid: null, //当前登录人guid
      pageTable: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
    };
  },
  filters: {
    listFilter(list) {
      let str='-'
      if(list&&list.length>0){
        // 区域
        let nameList=list.map((k)=>{
          return k.salesTerritoryName;
        });
        str=nameList.join('、')
      }
      return str
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.currentOrganisationName = userinfo.organisationName;
    this.getPageDetail();
    this.getBpmnUrl();
  },
  methods: {
    getSumAmount(list, type) {
      let sum = 0;
      if (type == 1) {
          list.forEach(item => {
              // sum += item.settleAmount;
              sum += Math.round(item.generalBudget * 100) / 100 ;
          })
      }
      if (type == 2) {
          list.forEach(item => {
            sum += Math.round(item.needPersonNum * 100) / 100;
          })

      }
      return sum
    },
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.approveVO && this.formData.approveVO.approveState);
    },
    //获取操作按钮显隐
    getBtnState(btnType) {
      return workFlowCommon.getBtnState(
        btnType,
        this.formData.approveVO && this.formData.approveVO.approveState,
        this.formData.approveVO && this.formData.approveVO.approveStaffGuids,
        this.currentStaffGuid,
        this.formData.approveVO && this.formData.approveVO.staffGuid,
        this.formData.bizApproveState
      );
    },
    // 显示表格选中任务数量展示 任务1 + n
    getTaskName(list) {
      let name = '-';
      if (list && list.length == 1) {
        name = list[0].taskContentName;
      }
      if (list && list.length > 1) {
        name = list[0].taskContentName + '等' + list.length  + '个任务';
      }
      return name;
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/marketing-plan/detail?marketingPlanGuid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData = res.data.data;
            self.tableData = self.formData.marketingPlanDetailList;
            self.approveGuid = self.formData.approveVO && self.formData.approveVO.approveGuid;
            // self.pageTable.totalRows = self.tableData.length;
            // self.pageTable.totalPage =
            //   (self.pageTable.totalRows + self.pageTable.pageSize - 1) / self.pageTable.pageSize;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //导出
    getExport() {
      let self = this;
      self.api
        .postJsonD(
          `/${serverConfig.msSalesPerformService}/marketing-plan/export-data?marketingPlanGuid=${this.formData.guid}`,
        )
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = '终端服务计划';
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    //下发
    getDownState(type, guid) {
      let self = this;
      let flg = false;
      self.tableData.forEach(i => {
        if(i.downState !== 'Y'){
          flg = true;
        }
      });
      if(!flg){
        self.$message.warning('已全部下发完毕！')
        return
      }
      self
        .$confirm('确定下发吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.fullscreenLoading = true;
          let marketingPlanDetailGuid = type == 1 ? guid : '';
          let marketingPlanGuid = type == 1 ? '' : self.formData.guid;
          self.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/marketing-plan/down-plan?marketingPlanDetailGuid=${marketingPlanDetailGuid}&marketingPlanGuid=${marketingPlanGuid}`,
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success('下发成功！');
                self.getPageDetail();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    // handleSizeChange(val) {
    //   let self = this;
    //   self.pageTable.pageSize = val;
    // },
    // handleCurrentChange(val) {
    //   let self = this;
    //   self.pageTable.pageIndex = val;
    // },
    getBpmnUrl() {
      if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.$route.query.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.$route.query.camundaDeploymentId +
          '&token=' +
          localStorage.token;
          this.iframeSh = true;
        console.log(this.srcs);
      } else {
        this.iframeSh = false;
      }
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm(messageConfig.FLOW_IS_CANCEL, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.approveGuid,
            flowType: self.flowType,
            approveStaffGuid: self.currentStaffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success(messageConfig.FLOW_CANCEL);
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/marketingPlanAdd',
        query: {
          // bizGuid: this.$route.query.bizGuid,
          guid: this.$route.query.guid,
          productGuid:this.$route.query.productGuid
        },
      });
    },
    toPass() {
      let self = this;
      self.approveSuggest = '';
      self.passDialogVisible = true;
    },
    toReject() {
      let self = this;
      self.approveSuggest = '';
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success(messageConfig.FLOW_PASS);
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success(messageConfig.FLOW_REJECT);
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 10px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.approve-img {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 78px;
  height: 78px;
}
/* 合同信息 */
.contract-base-box .el-col-12 {
  display: flex;
  line-height: 22px;
  margin-bottom: 20px;
}
.el-col-12:nth-child(2n + 1) .contract-base-title {
  flex-shrink: 0;
  width: 100px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title {
  flex-shrink: 0;
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
.select-task {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.plan-detail {
  display: flex;
  justify-content: space-between;
}
.total-tip {
  text-align: right;
  margin: 0 0 10px 0;
}

.total-tip span {
  color: #FF5F1F;
}
</style>
